import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationResetPassword = (onSuccess, onError) => {
    return {
        mutationFn: (userUuid) => {
            return client.post(replaceParameters(USERS.RESET_PASSWORD.url, { userId: userUuid }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationResetPassword;